import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "concierge__emoji_2_full",
  "use": "concierge__emoji_2_full-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" stroke=\"var(--color-icons-alt, #fff)\" stroke-linecap=\"round\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"concierge__emoji_2_full\">\n  <circle cx=\"16\" cy=\"16\" fill=\"var(--color-icons-warning, #f9e655)\" r=\"15.97\" stroke=\"none\" />\n  <circle cx=\"11.33\" cy=\"12.7\" r=\"1.48\" />\n  <circle cx=\"20.74\" cy=\"12.7\" r=\"1.4\" />\n  <line x1=\"9.98\" x2=\"22.05\" y1=\"22.6\" y2=\"21.55\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol